/**
 * Pure index-transition logic for the ARIA "roving tabindex" tablist pattern
 * (WAI-ARIA Authoring Practices) — kept separate from the DOM/React wiring
 * specifically so it can be verified with plain assertions, independent of
 * anything requiring a browser.
 *
 * Only ever ONE tab in a tablist should be in the normal Tab order at a
 * time (the active one, tabIndex=0); the rest are tabIndex=-1. Arrow keys
 * move focus AND selection between tabs; Tab itself moves focus out of the
 * tablist entirely, to whatever comes next in the page.
 */
export function getNextTabIndex(currentIndex, key, itemCount) {
  if (itemCount <= 0) return currentIndex;
  switch (key) {
    case 'ArrowRight':
    case 'ArrowDown':
      return (currentIndex + 1) % itemCount;
    case 'ArrowLeft':
    case 'ArrowUp':
      return (currentIndex - 1 + itemCount) % itemCount;
    case 'Home':
      return 0;
    case 'End':
      return itemCount - 1;
    default:
      return currentIndex;
  }
}

/** Keys getNextTabIndex actually handles — used to decide whether to
 * preventDefault() (stopping the arrow keys from scrolling the page) and
 * whether to re-render at all. */
export const NAVIGATION_KEYS = new Set(['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End']);
